/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import PerformanceGraphNILM from '../../../shared/PerformanceGraph/PerformanceGraphNILM';
import DetailSummaryComponent from '../../../shared/DetailSummaryComponent/DetailSummaryComponent';
import { MAGIC_VALUE, PreferredUnit } from '../../../shared/Utils/Constants';
import '../../../../scss/ViewDetailsTheme.scss';
import { getPerformanceGraphData } from '../../../shared/Utils/Utils';
import { getMaxConvertedValueFromArray } from '../../../shared/Utils/unitHandling/unitHandling';
import { getEnergyTotalUsagesGraphValues } from '../../../shared/Utils/unitHandling/EmaasSiteKpiDataScaling';
import { getNullCheckedAggregationSummaryData } from '../../../shared/Utils/EnergyUsagesViewDetailsUtils';
import { formatCommonEnergyDataForNILM } from '../../../shared/Utils/PortfolioEnergy/PortfolioEnergyVDUtils';
import { IEmaasEnergyUsageComponentDataArea } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import { ApiContext } from '../../../../context/ApiContext';
// import {oatSeries} from '../../../shared/PerformanceGraph/OATData';

export interface IEnergyUsagesAllUtilityDetailsComponentProps {
  data: IEmaasEnergyUsageComponentDataArea;
}

const oatData = [
  [1641061800000, 3.92],
  [1641148200000, 3.92],
  [1641234600000, 20.14],
  [1641321000000, 14.32],
  [1641407400000, 17.01],
  [1641493800000, 9.51],
  [1641580200000, 13.99],
  [1641666600000, 4.03],
  [1641753000000, 4.92],
  [1641839400000, 18.13],
  [1641925800000, 20.7],
  [1642012200000, 8.17],
  [1642098600000, 6.49],
  [1642185000000, 8.17],
  [1642271400000, 4.14],
  [1642357800000, 4.81],
  [1642444200000, 10.97],
  [1642530600000, 17.91],
  [1642617000000, 11.53],
  [1642703400000, 12.76],
  [1642789800000, 17.91],
  [1642876200000, 4.59],
  [1642962600000, 4.25],
  [1643049000000, 16.23],
  [1643135400000, 10.07],
  [1643221800000, 8.95],
  [1643308200000, 13.32],
  [1643394600000, 8.95],
  [1643481000000, 3.92],
  [1643567400000, 4.81],
  [1643653800000, 18.87],
  [1643740200000, 13.42],
  [1643826600000, 15.94],
  [1643913000000, 8.91],
  [1643999400000, 13.11],
  [1644085800000, 4.51],
  [1644172200000, 3.67],
  [1644258600000, 16.98],
  [1644345000000, 19.4],
  [1644431400000, 7.65],
  [1644517800000, 6.08],
  [1644604200000, 7.65],
  [1644690600000, 4.3],
  [1644777000000, 3.35],
  [1644863400000, 10.27],
  [1644949800000, 16.77],
  [1645036200000, 10.8],
  [1645122600000, 11.95],
  [1645209000000, 16.77],
  [1645295400000, 3.46],
  [1645381800000, 4.4],
  [1645468200000, 15.2],
  [1645554600000, 9.44],
  [1645641000000, 8.39],
  [1645727400000, 12.48],
  [1645813800000, 8.39],
  [1645900200000, 2.41],
  [1645986600000, 4.3],
  [1646073000000, 17.43],
  [1646159400000, 12.39],
  [1646245800000, 14.72],
  [1646332200000, 8.23],
  [1646418600000, 12.1],
  [1646505000000, 4.16],
  [1646591400000, 3.29],
  [1646677800000, 15.68],
  [1646764200000, 17.91],
  [1646850600000, 7.07],
  [1646937000000, 5.62],
  [1647023400000, 7.07],
  [1647109800000, 3.97],
  [1647196200000, 3.58],
  [1647282600000, 9.49],
  [1647369000000, 15.49],
  [1647455400000, 9.97],
  [1647541800000, 11.04],
  [1647628200000, 15.49],
  [1647714600000, 3.39],
  [1647801000000, 4.07],
  [1647887400000, 14.04],
  [1647973800000, 8.71],
  [1648060200000, 7.74],
  [1648146600000, 11.52],
  [1648233000000, 7.74],
  [1648319400000, 3],
  [1648405800000, 3.19],
  [1648492200000, 9.68],
  [1648578600000, 10.65],
  [1648665000000, 11.62],
  [1648751400000, 10.85],
  [1648837800000, 10.01],
  [1648924200000, 3.76],
  [1649010600000, 4.01],
  [1649097000000, 9.6],
  [1649183400000, 7.09],
  [1649269800000, 10.43],
  [1649356200000, 9.35],
  [1649442600000, 10.85],
  [1649529000000, 4.17],
  [1649615400000, 3.92],
  [1649701800000, 9.51],
  [1649788200000, 9.6],
  [1649874600000, 6.09],
  [1649961000000, 8.18],
  [1650047400000, 8.93],
  [1650133800000, 3.76],
  [1650220200000, 3.76],
  [1650306600000, 9.18],
  [1650393000000, 9.51],
  [1650479400000, 7.51],
  [1650565800000, 9.18],
  [1650652200000, 7.51],
  [1650738600000, 3.34],
  [1650825000000, 3.92],
  [1650911400000, 9.18],
  [1650997800000, 8.62],
  [1651084200000, 6.84],
  [1651170600000, 6.77],
  [1651257000000, 5.76],
  [1651343400000, 4.3],
  [1651429800000, 9.37],
  [1651516200000, 9.85],
  [1651602600000, 9.63],
  [1651689000000, 8.99],
  [1651775400000, 8.3],
  [1651861800000, 5.03],
  [1651948200000, 4.31],
  [1652034600000, 6.79],
  [1652121000000, 6.89],
  [1652207400000, 7.46],
  [1652293800000, 8.19],
  [1652380200000, 7.48],
  [1652466600000, 4.9],
  [1652553000000, 4.65],
  [1652639400000, 10.45],
  [1652725800000, 8.45],
  [1652812200000, 10.69],
  [1652898600000, 10.16],
  [1652985000000, 10.06],
  [1653071400000, 7.11],
  [1653157800000, 4.64],
  [1653244200000, 10.68],
  [1653330600000, 9.32],
  [1653417000000, 8.72],
  [1653503400000, 8.59],
  [1653589800000, 8.28],
  [1653676200000, 6.14],
  [1653762600000, 4.64],
  [1653849000000, 9.51],
  [1653935400000, 10.98],
  [1654021800000, 11.91],
  [1654108200000, 11.14],
  [1654194600000, 9.62],
  [1654281000000, 6.78],
  [1654367400000, 4.89],
  [1654453800000, 10.96],
  [1654540200000, 11.05],
  [1654626600000, 11.64],
  [1654713000000, 10.86],
  [1654799400000, 9.19],
  [1654885800000, 7.06],
  [1654972200000, 5.25],
  [1655058600000, 12.65],
  [1655145000000, 11.77],
  [1655231400000, 13.25],
  [1655317800000, 11.38],
  [1655404200000, 10.2],
  [1655490600000, 7.15],
  [1655577000000, 4.39],
  [1655663400000, 10.24],
  [1655749800000, 10.42],
  [1655836200000, 11.92],
  [1655922600000, 10.87],
  [1656009000000, 10.1],
  [1656095400000, 5.92],
  [1656181800000, 2.56],
  [1656268200000, 16.98],
  [1656354600000, 10.31],
  [1656441000000, 11.18],
  [1656527400000, 10.84],
  [1656613800000, 9.53],
  [1656700200000, 7.28],
  [1656786600000, 5.11],
  [1656873000000, 10.13],
  [1656959400000, 10.73],
  [1657045800000, 12.08],
  [1657132200000, 11.41],
  [1657218600000, 10.38],
  [1657305000000, 7.29],
  [1657391400000, 4.72],
  [1657477800000, 9.87],
  [1657564200000, 10.62],
  [1657650600000, 10.98],
  [1657737000000, 10.13],
  [1657823400000, 9.93],
  [1657909800000, 7.12],
  [1657996200000, 5.4],
  [1658082600000, 2.18]
];
const EmaasNILMEnergyUsagesComponent = (
  props: IEnergyUsagesAllUtilityDetailsComponentProps
) => {
  const { data } = props;
  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;
  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }
  fromUnit =
    userPreferedUnit === 'megajoule'
      ? userPreferedUnit
      : props.data.sourceType && props.data.sourceType.toLowerCase() === 'gas'
      ? PreferredUnit.Gas
      : (PreferredUnit.Electricity as any);
  const {
    nilmAggregation,
    performanceAggregation,
    aggregationsStartDate,
    performanceAggregationApplied,
    energyMeasurementUnit,
    intervalType
  } = data;
  const {
    conversionType,
    aggregationSummaryData,
    maxValueUnitConversion,
    aggregationsEndDate,
    deviationScaledData
  } = formatCommonEnergyDataForNILM(
    data,
    fromUnit,
    apiContext.showChangeWhenData,
    true
  );

  const newPerformanceAggregation = nilmAggregation
    ? nilmAggregation.energyUsageAggregation.map((aggr: any) => {
        return {
          consumption: aggr.totalConsumption,
          baselineConsumption: aggr.totalBaselineConsumption,
          consumptionDate: aggr.usageDateTime
        };
      })
    : [];

  const graphValuesArray = getEnergyTotalUsagesGraphValues(
    newPerformanceAggregation
  );
  const maxGraphValueUnitConversion = getMaxConvertedValueFromArray(
    conversionType,
    conversionType.toLowerCase() === 'gas' ? energyMeasurementUnit : fromUnit, //energyMeasurementUnit,
    graphValuesArray,
    energyMeasurementUnit
  );
  // const comparisonData: any = getPerformanceGraphData(
  //   performanceAggregation,
  //   energyMeasurementUnit,
  //   maxGraphValueUnitConversion.Unit,
  //   performanceAggregationApplied,
  //   conversionType
  // );

  const comparisonData: any = getPerformanceGraphData(
    newPerformanceAggregation,
    energyMeasurementUnit,
    maxGraphValueUnitConversion.Unit,
    intervalType,
    conversionType
  );

  comparisonData.oatSeries = oatData;

  const alternateSummary = {
    totalConsumption: null,
    totalBaselineConsumption: null,
    absoluteTotalConsumption: null,
    absoluteTotalBaselineConsumption: null,
    totalEnergyDeviation: null,
    totalEnergyDeviationPercentage: null
  };

  const isNullCheckedData = getNullCheckedAggregationSummaryData(
    aggregationSummaryData,
    nilmAggregation && nilmAggregation.summary
      ? nilmAggregation.summary
      : alternateSummary
  );

  return (
    <div className="allUtility-performance-detail-container">
      <div>
        <DetailSummaryComponent
          aggregationData={isNullCheckedData}
          measurementUnit={maxValueUnitConversion.Unit}
          detailType="detailSummaryWithoutCurrencyNILM"
          category="EnergyUsage"
          deviationScaledData={deviationScaledData}
          fromCarbonScopeOne={true}
        />
        <PerformanceGraphNILM
          chartSeries={comparisonData}
          startTime={aggregationsStartDate}
          endTime={aggregationsEndDate}
          // aggregationType={performanceAggregationApplied}
          aggregationType={intervalType}
          height={''}
          spacing={[
            MAGIC_VALUE.THIRTY,
            MAGIC_VALUE.ZERO,
            MAGIC_VALUE.ZERO,
            MAGIC_VALUE.ZERO
          ]}
        />
      </div>
    </div>
  );
};

export default memo(EmaasNILMEnergyUsagesComponent);
